module.exports = __webpack_public_path__ + "static/media/about-zo-goed-als-oud-vintage-design-furniture-online.233cc774.jpg";